import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

import { Bau365DataAccessFairDataModule, DataAccessProductsService } from '@planone/bau365/data-access-fair-data';
import { Bau365FeatureBreadcrumbModule, BreadcrumbHelper } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureUserProfileSharedModule } from '@planone/bau365/feature-user-profile';
import { Bau365FeatureWatchlistSharedModule } from '@planone/bau365/feature-watchlist';
import { Bau365UiShellModule } from '@planone/bau365/ui-shell';
import { SharedUtilFeatureFlagsModule } from '@planone/shared/data-access-feature-flags';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilMetaModule } from '@planone/shared/util-meta';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { ArticleGenerator, BreadcrumbGenerator } from '@planone/shared/util-structured-data';
import { SharedUiSwiperModule } from '@planone/shared-feature-swiper';

import { Bau365FeaturePostsSharedModule } from './bau365-feature-posts-shared.module';
import { PagePostDetailsComponent } from './page-post-details/page-post-details.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: ':id',
        pathMatch: 'full',
        component: PagePostDetailsComponent,
        data: {
          userSessionRequired: true,
          analyticsPageType: 'post-details',
          googleAnalytics: {
            customTracking: true,
          },
          snowplow: {
            customTracking: true,
          },
        },
      },
    ]),
    Bau365DataAccessFairDataModule,
    MatCardModule,
    MatChipsModule,
    Bau365UiShellModule,
    SharedUiElementsModule,
    SharedUtilPipelinesModule,
    MatButtonModule,
    MatIconModule,
    SharedUiSwiperModule,
    MatTabsModule,
    SharedUtilMetaModule,
    Bau365FeatureWatchlistSharedModule,
    Bau365FeaturePostsSharedModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureUserProfileSharedModule,
    SharedUtilFeatureFlagsModule,
  ],
  declarations: [PagePostDetailsComponent],
  providers: [ArticleGenerator, BreadcrumbGenerator, DataAccessProductsService, BreadcrumbHelper],
})
export class Bau365FeaturePostsModule {}
